import { buttonClassName } from '@emailforge/ui';

type Provider = {
  id: string;
  label: string;
  href: string;
  logo: JSX.Element;
};

const PROVIDERS: Provider[] = [
  {
    id: 'google',
    label: 'Continue with Google',
    href: '/api/auth/oauth/google',
    logo: (
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09a6.6 6.6 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
        />
      </svg>
    ),
  },
  {
    id: 'github',
    label: 'Continue with GitHub',
    href: '/api/auth/oauth/github',
    logo: (
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.32-1.27-1.67-1.27-1.67-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.02 1.75 2.68 1.24 3.34.95.1-.74.4-1.24.72-1.53-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.05 0 0 .96-.31 3.15 1.18a10.93 10.93 0 0 1 5.74 0c2.19-1.49 3.15-1.18 3.15-1.18.62 1.59.23 2.76.11 3.05.74.81 1.18 1.84 1.18 3.1 0 4.43-2.69 5.41-5.26 5.69.41.36.78 1.05.78 2.13v3.16c0 .31.21.68.8.56 4.56-1.52 7.85-5.83 7.85-10.91C23.5 5.65 18.35.5 12 .5z"
        />
      </svg>
    ),
  },
  {
    id: 'discord',
    label: 'Continue with Discord',
    href: '/api/auth/oauth/discord',
    logo: (
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
        <path
          fill="#5865F2"
          d="M20.32 4.92A19.9 19.9 0 0 0 15.4 3.4a.07.07 0 0 0-.08.04c-.21.38-.45.88-.61 1.27a18.4 18.4 0 0 0-5.42 0c-.16-.4-.4-.89-.62-1.27a.08.08 0 0 0-.08-.04A19.85 19.85 0 0 0 3.68 4.92a.07.07 0 0 0-.03.03C.53 9.46-.32 13.86.1 18.21a.08.08 0 0 0 .03.05 20.06 20.06 0 0 0 6.04 3.05.08.08 0 0 0 .08-.03c.47-.64.88-1.31 1.24-2.02a.08.08 0 0 0-.04-.1c-.66-.25-1.29-.55-1.9-.9a.08.08 0 0 1 0-.13c.13-.1.26-.2.38-.3a.07.07 0 0 1 .08-.01c3.99 1.82 8.3 1.82 12.24 0a.07.07 0 0 1 .08.01c.13.1.25.2.38.3a.08.08 0 0 1 0 .13c-.61.36-1.24.65-1.9.9a.08.08 0 0 0-.04.1c.36.71.78 1.38 1.24 2.02a.08.08 0 0 0 .08.03 20 20 0 0 0 6.05-3.05.08.08 0 0 0 .03-.05c.5-5.04-.84-9.4-3.55-13.26a.06.06 0 0 0-.03-.03zM8.02 15.56c-1.18 0-2.16-1.09-2.16-2.42 0-1.34.96-2.42 2.16-2.42 1.21 0 2.18 1.09 2.16 2.42 0 1.33-.96 2.42-2.16 2.42zm7.97 0c-1.18 0-2.16-1.09-2.16-2.42 0-1.34.96-2.42 2.16-2.42 1.21 0 2.18 1.09 2.16 2.42 0 1.33-.95 2.42-2.16 2.42z"
        />
      </svg>
    ),
  },
];

export function OAuthButtons() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {PROVIDERS.map((p) => (
        <a
          key={p.id}
          href={p.href}
          className={buttonClassName()}
          style={{ height: 42, justifyContent: 'center', textDecoration: 'none', gap: 10 }}
        >
          {p.logo}
          {p.label}
        </a>
      ))}
    </div>
  );
}
